<template>
  <b-navbar sticky type="light">
    <div class="col-6"></div>
    <b-navbar-brand to="/"><img :alt="$t('site_title')" src="../assets/img/logo.svg"/></b-navbar-brand>
    <b-col class="col-6">
      <b-navbar-nav>
        <logout-button class="ml-auto mr-sm-5" v-if="loggedIn"></logout-button>
        <div v-else>&nbsp;</div>
      </b-navbar-nav>
    </b-col>
  </b-navbar>
</template>

<script>
import LogoutButton from './LogoutButton'
import { mapGetters } from 'vuex'

export default {
  name: 'navbar',
  components: { LogoutButton },
  computed: {
    ...mapGetters('user', ['loggedIn'])
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .navbar {
    font-family: $font-family-sans-serif;
    background: $accent;
    padding: 1em 0;

    .navbar-nav {
      .nav-link {
        font-weight: bold;

        &.router-link-exact-active {
          color: $body-color;
        }
      }
    }

    .navbar-brand {
      position: relative;
      width: 0;
      margin: 0;

      img {
        width: 8em;
        height: 4.5em;
        left: -4em;
        top: -0.25em;
        position: absolute;
      }
    }
  }
</style>
